import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "rrUiCoreEnumDescription",
  standalone: true,
})
export class UiCoreEnumDescriptionPipe implements PipeTransform {
  transform(value: string, enumType: object, emptyPlaceholder = "-"): string {
    if (value && enumType) {
      return Object.keys(enumType).find((key) => enumType[key as keyof object] === value) || value;
    }
    return emptyPlaceholder;
  }
}
